import http from '../plugins/axios'

export const getAllRequestQuoteList = async (params) => {
  try {
    const response = await http.get(`/api/v2/request-quote`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailRequestQuotePrice = async (quoteId, params) => {
  try {
    const response = await http.get(`/api/v2/request-quote/${quoteId}/price`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addRequestQuote = async (payload) => {
  const config = {
    headers: {
      Identifier: 'Manage',
    },
  }
  try {
    const response = await http.post(`/api/v2/request-quote`, payload, config)
    return response.data
  } catch(error) {
    throw error
  }
}

export const addRequestQuoteBulkPrice = async (id, payload) => {
  try {
    const response = await http.post(`/api/v2/request-quote/${id}/bulk-price`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateRequestQuote = async (quoteId, payload) => {
  try {
    const response = await http.put(`/api/v2/request-quote/${quoteId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateRequestQuoteBulkPrice = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/request-quote/${id}/bulk-price`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const uploadDocumentRequestQuote = async (quoteId, payload) => {
  try {
    const response = await http.post(`/api/v2/request-quote/${quoteId}/documents`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateUrlPublicRequestQuote = async (quoteId) => {
  try {
    const response = await http.post(`/api/v2/request-quote/${quoteId}/generate-url`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateShortUrlRequestQuote = async (quoteId) => {
  try {
    const response = await http.post(`/api/v2/request-quote/${quoteId}/short-url`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteRequestQuote = async (quoteId) => {
  try {
    const response = await http.delete(`/api/v2/request-quote/${quoteId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteDocumentRequestQuote = async (quoteId, payload) => {
  try {
    const response = await http.delete(`/api/v2/request-quote/${quoteId}/documents`, { data: payload })
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteRequestQuoteBulkPrice = async (id, payload) => {
  try {
    const response = await http.delete(`/api/v2/request-quote/${id}/bulk-price`, { data: payload })
    return response.data
  } catch(error) {
    throw error
  }
}

